import React, { useState, useEffect, useContext, Component, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axiosInstance, { keyLogin } from '../../axiosInstance';
import setCookie from '../../helper/setCookie';
import getCookie from '../../helper/getCookie';
import { encrypt } from '../../helper/encryption';
import LoginComponents from '../components/LoginComponents';
import PropTypes from 'prop-types';
import HeaderPage from '../components/HeaderPage';
import NavBar from '../components/NavBar';

function UserLogin({ updateAuthStatus }) {
  return (
    <>
      <Header />
      <main className="page-content bg-light mypadding overflow-auto pb-4 px-0" >


        <div
          className="col-12 m-auto rounded-3 p-4 "
          style={{ maxWidth: 450, minHeight: 400 }}
        >
          {/* Passing the function to LoginComponents correctly */}
          <LoginComponents updateAuth={updateAuthStatus} />
        </div>



      </main>
      <Footer />

    </>
  );
}

// ✅ FIXED: updateAuthStatus is a function, not a boolean
UserLogin.propTypes = {
  updateAuthStatus: PropTypes.func.isRequired,
};

// ✅ Optional: improve performance with memo
export default React.memo(UserLogin);
